import { Box, Button, Typography } from "@mui/material";
import AuthCard from "../AuthCard/AuthCard.wrapper";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate, useSearch } from "@tanstack/react-router";
import axios from "axios";
import { toast } from "react-toastify";

const AccountVerified = () => {

    function useQueryParams() {
        const { search } = useLocation();
        return new URLSearchParams(search);
    }
    const navigate = useNavigate();
    const query = useQueryParams();
    const userId = query.get("userId");
    const token = query.get("token");

    const mutation = useMutation({
        mutationFn: async () => {
            const response = await axios.put("https://interviewer.runasp.net/api/users/confirm-email", {
                userId,
                token,
            });
            return response.data;
        },
        onSuccess: (data) => {
            toast.success('Account verified successfully!')
            navigate({ to: '/login' });
        },
        onError: (error) => {
            toast.error('Error verifying account')
            console.error(error);
        }
    })
    
    return (
        <AuthCard>
            <Box>
                <Typography variant="h1">Almost There!</Typography>
                <Typography variant="h1">Verify Your Account</Typography>
                <Typography sx={{paddingTop: '8px'}}>
                    Click the button below to complete your email verification and activate your account.
                </Typography>
            </Box>

            <Button variant="contained" onClick={() => mutation.mutate()} sx={{marginTop: "40px"}}>Verify</Button>
        </AuthCard>
    )
};

export default AccountVerified